import { Fragment, useEffect, useState } from "react";
import Header from "../common/Header";
import {  useForm } from "./../context/FormContext";
import Footer from "../common/Footer";
import { Box, Button, Modal, Typography, FormControlLabel, CircularProgress } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import KioskForm from "./Kiosk/KioskForm";
import LockerForm from "./Locker/LockerForm";
import ParcelPointForm from "./ParcelPoint/ParcelPointForm";
import DoorForm from "./Door/DoorForm";
import Summary from './Summary';
import { useNavigate } from "react-router";
import SelectedServices from "./SelectedServices";
import { pickup_services } from './../data'
import submitParcel from './../api/parcel';
import sendWhatsappNotification from '../api/sendWhatsappNotification';
import axiosInstance from "./../api/axiosConfig";
import SelectPaymentOptions from './SelectPaymentOptions';

const ServiceSwitch =  ({ type,payment_type }) => {
    let navigate = useNavigate();
    const { formData, updateField,validateForm, errors } = useForm();
    const [returnData, setReturnData] = useState({})
    const [serviceDeliveryError, setServiceDeliveryError] = useState('')
    const [cartError, setCartError] = useState('')
    const [submitError, setsubmitError] = useState(false)
    const [modalOpen, setModalOpen] = useState(false);
    const [modalCartErrorOpen, setCartErrorOpen] = useState(false);
    const [paymentOptionmodalOpen, setpaymentOptionmodalOpen] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [loadingSubmit, setloadingSubmit] = useState(false);
    const [selectedPaymentOption, setselectedPaymentOption] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const rates = formData?.parcelSizes?.rates ?? [];
    const selectedRate = rates.find(
    r => r?.service_level?.code === formData.parcelPrice
    );

    const rate_amount = parseFloat(selectedRate?.rate ?? 0).toFixed(2);
    const ParcelPointPayload = {
        type,
        accepted:true,
        collection_address:{
            type: 'pickup point'
        },
        collection_contact: {
            name: formData?.senderName,
            email: formData?.senderEmail,
            mobile_number: formData?.senderNumber
        },
        delivery_contact: {
            name: formData?.receiverName,
            email: formData?.receiverEmail,
            mobile_number: formData?.receiverNumber
        },
        parcels: [
            {
            parcel_description: "",
            submitted_length_cm: 1,
            submitted_width_cm: 1,
            submitted_height_cm: 1,
            submitted_weight_kg: 1,
            },
        ],
        status: "payment-pending",
        platform: "in-store",
        deliveryInstruction:formData?.deliveryInstruction??"",
        special_instructions_collection: "None",
        special_instructions_delivery: "",
        service_level_code: type.includes('pp_') ? formData?.parcelPrice : "ECO",
        delivery_address: type.includes('_door') ? {
            company: formData?.companyName,
            street_address: formData?.streetAddress,
            local_area: formData?.suburb,
            suburb: formData?.suburb,
            city: formData?.city,
            code: formData?.postCode,
            zone: formData?.province?.id,
            country: "South Africa",
            type: formData?.addressType ?? "residential",
            lat:formData?.lat??null,
            lng:formData?.lng??null,
        } : {
            terminal_id: formData?.selectedLocker?.lockerId??null
        },
        rate_amount
    }

    const setPaymentOptionNow = (option) => {
        setselectedPaymentOption(option);
        proceedToPayNow(option.value);
    } 

    const proceedToPayNow = async (payment_option) => {
        try {
            setPaymentLoading(true);
          
            const parameter = ParcelPointPayload;
      
           
            let responseData = await submitDelivery('qr-web/create-shipment-cart', parameter);
               
            if(type.includes('pp_')){
                localStorage.setItem('shipment_details', JSON.stringify(parameter));
            }
            
            if(responseData?.success === true){
                redirectToPayment(responseData.data,payment_option);
            } else {
                setPaymentLoading(false);
            }
        } catch (err) {
            setPaymentLoading(false);
            setCartError(err.message);
            setCartErrorOpen(true);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        updateField('service_type',type);
    },[]);

    useEffect(() => {
        // localStorage.removeItem('cart_id');
    }, [formData]);

    useEffect(() => {
        const saved = localStorage.getItem('shipment_details');
        if (!saved) return;
        
        const payload = JSON.parse(saved);
        if(type.includes('pp_')){
            restoreFromPayload(payload);
        }
    }, []);

    const restoreFromPayload = (payload) => {
       
        const isDoor = payload.delivery_address?.street_address !== undefined; 
        updateField('senderName', payload.collection_contact?.name || '');
        updateField('senderEmail', payload.collection_contact?.email || '');
        updateField('senderNumber', payload.collection_contact?.mobile_number || '');
        updateField('receiverName', payload.delivery_contact?.name || '');
        updateField('receiverEmail', payload.delivery_contact?.email || '');
        updateField('receiverNumber', payload.delivery_contact?.mobile_number || '');
        updateField('deliveryInstruction', payload.deliveryInstruction || '');
        updateField('parcelPrice', payload.service_level_code || 'ECO');
        updateField('accepted', payload.accepted || true);
        if (isDoor) {
            const provinceData = [
                { id: "EC", label: "Eastern Cape" },
                { id: "FS", label: "Free State" },
                { id: "GP", label: "Gauteng" },
                { id: "KZN", label: "KwaZulu-Natal" },
                { id: "LP", label: "Limpopo" },
                { id: "MP", label: "Mpumalanga" },
                { id: "NW", label: "North West" },
                { id: "NC", label: "Northern Cape" },
                { id: "WC", label: "Western Cape" },
            ];
            updateField('companyName', payload.delivery_address?.company || '');
            updateField('streetAddress', payload.delivery_address?.street_address || '');
            updateField('suburb', payload.delivery_address?.suburb || '');
            updateField('city', payload.delivery_address?.city || '');
            updateField('postCode', payload.delivery_address?.code || '');
            const matchedProvince = provinceData.find(
                (p) => p.id === payload.delivery_address?.zone
                ) || null;
            updateField('province', matchedProvince || null);
            updateField('addressType', payload.delivery_address?.type || 'residential');
        }
    };
    
    const handleBack = (event) => {
        event.preventDefault();
        const type_data = (type.includes('pp_')) ? 'pp' : '';
        if(currentStep === 0 ){
            navigate(`/${type_data}`)
        } else {
            if (currentStep > 0) {
                setCurrentStep((prev) => prev - 1);
                window.scrollTo(0, 0);
            }
        }

    }

    const submitDelivery = async (url, parameter) => {
        try {
            setloadingSubmit(true);
            const response = (type.includes('pp_')) ? await submitParcel(parameter,url) : await axiosInstance.post(url, parameter);
            const response_data = (type.includes('pp_')) ? response : response.data;
            setReturnData(response_data);
            if(!type.includes('pp_')){
                sendWhatsappNotification({ waybill: response?.data?.short_tracking_reference, mobile: formData?.senderNumber });
                setsubmitError(false);
                setloadingSubmit(false)
            } else {
                setsubmitError(false);
                setloadingSubmit(false);
                // setPaymentLoading(false);
                // setpaymentOptionmodalOpen(false);
            }
            return response_data;
        } catch (err) {
            setloadingSubmit(false);
            setsubmitError(true);
            setServiceDeliveryError(err);
            throw err;
        } finally {
            if(!type.includes('pp_')){
                setModalOpen(true);
                setloadingSubmit(false)
            } else {
                if(payment_type === 'cash'){
                    setModalOpen(true);
                    setloadingSubmit(false);
                    setPaymentLoading(false);
                }
            }
        }
    }

    const handleSubmitForm = (event) => {
        event.preventDefault();
        
        let today = new Date();
        today.setDate(today.getDate() + 5);

        if (type === 'pp_to_door' && currentStep === 0 && !formData.parcelSizes) { 
            alert("Please select a parcel size or service");
            return;
        }
        const senderparts = formData?.senderName?.trim().split(/\s+/) || [];
        const senderlastName = senderparts.length > 1 ? senderparts[senderparts.length - 1] : null;
        if(!senderlastName){
            alert("Sender last name is required");
            return;
        }
        const receiverparts = formData?.receiverName?.trim().split(/\s+/) || [];
        const receiverlastName = receiverparts.length > 1 ? receiverparts[receiverparts.length - 1] : null;
        if(!receiverlastName){
            alert("Receiver last name is required");
            return;
        }
       
        if (validateForm()) {
            if(currentStep === 1){
                if(!type.includes('pp_')){
                    const parameter = {
                        collection_address: {
                            type: "counter",
                            company: "Kiosk Pre-Booking [Change to your cash account]",
                            street_address: "Pre Booking",
                            local_area: "Pre Booking",
                            city: "Pre Booking",
                            code: "0000",
                            zone: "Gauteng",
                            country: "ZA",
                            lat: -26.004105079236897,
                            lng: 27.940885290245756,
                        },
                        collection_contact: {
                            name: formData?.senderName,
                            email: formData?.senderEmail,
                            mobile_number: formData?.senderNumber
                        },
                        delivery_contact: {
                            name: formData?.receiverName,
                            email: formData?.receiverEmail,
                            mobile_number: formData?.receiverNumber
                        },
                        status: "payment-pending",
                        special_instructions_delivery:formData?.deliveryInstruction,
                        special_instructions_collection: "",
                        service_level_code: "ECO",
                        delivery_address: type.includes('_door') ? {
                            company: formData?.companyName,
                            street_address: formData?.streetAddress,
                            local_area: formData?.suburb,
                            suburb: formData?.suburb,
                            city: formData?.city,
                            code: formData?.postCode,
                            zone: formData?.province.id,
                            country: "South Africa",
                            type: formData?.addressType
                        } : {
                            company: formData?.selectedLocker?.name,
                            street_address: formData?.selectedLocker?.address.address,
                            local_area: "",
                            suburb: "",
                            city: "",
                            code: formData?.selectedLocker?.address.postal_code,
                            zone: "",
                            country: "South Africa",
                            lat:formData?.selectedLocker?.address.latitude,
                            lng:formData?.selectedLocker?.address.longitude,
                            type: (type.includes('_locker')) ? 'locker' : 'counter'
                        },
                        collection_min_date: `${today.toISOString()}`,
                        collection_after: "08:00",
                        collection_before: "18:00",
                        mute_notifications: true,
                        declared_value: 0,
                        custom_tracking_reference: "",
                        parcels: [
                            {
                            parcel_description: "",
                            submitted_length_cm: 1,
                            submitted_width_cm: 1,
                            submitted_height_cm: 1,
                            submitted_weight_kg: 1,
                            },
                        ],
                    }
                    
                    submitDelivery("shipments",parameter);
                } else {
                    if(payment_type === 'cash'){
                        const parameter = ParcelPointPayload;
                        submitDelivery("shipments",parameter);
                    } else {
                         setloadingSubmit(true);
                        setpaymentOptionmodalOpen(true);
                    }
                }
            } else {
                setCurrentStep((prev) => prev + 1);
            }
        } else {
            console.log(errors);
        }
    }

    const isCash = payment_type === 'cash' ? 'Submit' : 'Proceeed to payment'; 

    const redirectToPayment = (data, option) => {
        try {
            let payment_option = '';
            let payment_stitch_type = '';
            if (option.includes("stitch-")) {
                const parts = option.split("-");
                payment_option = parts[0];
                payment_stitch_type = parts[1];
            } else {
                payment_option = option;
            }
            const params = new URLSearchParams({
                transaction_id: 'QR-'+data.id,
                amount: rate_amount, 
                name_first: formData?.senderName?.split(' ')[0] ?? '',
                name_last: formData?.senderName?.split(' ')[1] ?? '',
                email_address: formData?.senderEmail ?? '',
                callback_url: `${process.env.REACT_APP_BACKEND_ENDPOINT}qr-web/qrweb-callback`,
                return_url: baseUrl+'/payment/pp',
            });
            if(payment_stitch_type){
                params.append("type",payment_stitch_type);
            }
        
            const payment_url = (process.env.REACT_APP_ENV === 'production') ? 'https://payments.api-pudo.co.za/' : 'https://test-payments.api-pudo.co.za/';
            // const payment_url = 'https://payments.api-pudo.co.za/';
            window.location.href = `${payment_url}${payment_option}/pay?${params.toString()}`;
        } catch (error) {
            setPaymentLoading(false); 
        }
    };

    const closeCartErrorModal = () => {
        setCartErrorOpen(false);
    };
    
    const closeModal = () => {
        setModalOpen(false);
        let payment_append = '';
        if(payment_type){
            payment_append = '/'+payment_type
        }
        if (submitError === false) {
            let redirect_to = type.includes('pp_') ? 'pp' : '';
            navigate(`/${redirect_to}${payment_append}`);
        }
    };

    const closepaymentOptionModal = () => {
        setpaymentOptionmodalOpen(false);
        setloadingSubmit(false);
        setselectedPaymentOption(null);
    };

    return <Fragment>
        <Header />
        <main className="flex-1 pt-24 pb-16">
            <div className="max-w-7xl m-auto px-4 md:px-16">
                <div style={{ margin: "2vh" }} />
                <form onSubmit={(e) => handleSubmitForm(e)}>
                    <div style={{ margin: "3vh" }} />
                    <SelectedServices selected_dropoff={type.split("_to_")[0]} selected_pickup={type.split("_to_")[1]} selected_service={pickup_services.filter(value => value.value === type.split("_to_")[1])} />
                    <div style={{ margin: "3vh" }} />
                    { (currentStep === 0) ? renderServiceForm(type, formData) : <Summary type={type} data={formData}  /> }
                    <div style={{ margin: "3vh" }} />
                    {
                            (currentStep === 1) ? (
                                <Box>
                                    <FormControlLabel
                                        xs={{
                                            color: 'white'
                                        }}
                                        control={
                                            <Checkbox
                                                required
                                                checked={formData.accepted || false}
                                                onChange={(e) => updateField('accepted', e.target.checked)}
                                                color="primary"
                                            />
                                        }
                                        label="I have read and agree with the terms and conditions"
                                    />
                                </Box>
                            ) : null
                            
                        
                    }
                    
                    <div className="flex justify-end">
                        <button onClick={(e) => handleBack(e)} className="border-[#2B549A] border rounded-md px-16 py-2 hover:bg-[#2B549A] hover:text-white"> Back </button>
                        <button disabled={(loadingSubmit === false) ? false : true} type="submit" className="bg-[#2B549A] border-[#2B549A] border rounded-md px-16 py-[6.5px]  text-white ml-2">
                            {(loadingSubmit) ? <CircularProgress size="15px" className="success" color="primary" /> :(currentStep === 1) ? ((type.includes('pp_')) ? isCash : 'Submit') : 'Next'}
                        </button>    
                    </div>
                </form>
            </div>
        </main>
        <Footer />

        <Modal open={modalCartErrorOpen} onClose={closeCartErrorModal} aria-labelledby="booking-result-title" >
            <Box
                className="w-[92%] sm:w-[480px] md:w-[520px] lg:w-[560px] bg-white rounded-xl shadow-2xl p-6 sm:p-8 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
                <div className="flex flex-col items-center text-center space-y-4">

                    <ErrorOutlineIcon
                        sx={{ fontSize: 60 }}
                        className="text-red-500"
                    />

                    <Typography
                        id="booking-result-title"
                        variant="h6"
                        className="font-semibold text-red-600"
                    >
                        Booking Failed
                    </Typography>

                    <Typography className="text-gray-600">
                        {cartError}
                    </Typography>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={closeCartErrorModal}
                        className="mt-4 w-full sm:w-auto"
                    >
                        Close
                    </Button>
                </div>
              
            </Box>
        </Modal>

        <Modal
            open={modalOpen}
            onClose={closeModal}
            aria-labelledby="booking-result-title"
        >
            <Box
                className="w-[92%] sm:w-[480px] md:w-[520px] lg:w-[560px] 
                        bg-white rounded-xl shadow-2xl 
                        p-6 sm:p-8 
                        absolute top-1/2 left-1/2 
                        -translate-x-1/2 -translate-y-1/2"
            >
                {submitError === false ? (
                    <div className="flex flex-col items-center text-center space-y-4">

                        <CheckCircleOutlineIcon
                            sx={{ fontSize: 60 }}
                            className="text-green-500"
                        />

                        <Typography
                            id="booking-result-title"
                            variant="h6"
                            className="font-semibold"
                        >
                            Thank you for your booking
                        </Typography>

                        <Typography className="text-gray-600">
                            Your Reference #
                        </Typography>

                        <Typography className="font-semibold text-lg text-blue-600">
                            {type.includes("pp_")
                                ? returnData.custom_tracking_reference
                                : returnData.short_tracking_reference}
                        </Typography>

                        <Typography className="text-gray-500 text-sm">
                            You will shortly receive a WhatsApp notification confirming your waybill #
                        </Typography>

                        <Typography className="text-gray-500 text-sm">
                            You will be redirected to the homepage after clicking close.
                        </Typography>

                        <Button
                            variant="contained"
                            onClick={closeModal}
                            className="mt-4 w-full sm:w-auto"
                        >
                            Close
                        </Button>
                    </div>
                ) : (
                    <div className="flex flex-col items-center text-center space-y-4">

                        <ErrorOutlineIcon
                            sx={{ fontSize: 60 }}
                            className="text-red-500"
                        />

                        <Typography
                            id="booking-result-title"
                            variant="h6"
                            className="font-semibold text-red-600"
                        >
                            Booking Failed
                        </Typography>

                        <Typography className="text-gray-600">
                            {serviceDeliveryError.message}
                        </Typography>

                        <Button
                            variant="contained"
                            color="error"
                            onClick={closeModal}
                            className="mt-4 w-full sm:w-auto"
                        >
                            Close
                        </Button>
                    </div>
                )}
            </Box>
        </Modal>

        <Modal
            open={paymentOptionmodalOpen}
            onClose={closepaymentOptionModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                className="w-[92%] sm:w-[480px] md:w-[520px] lg:w-[560px] 
                        bg-white rounded-xl shadow-2xl 
                        p-6 sm:p-8 
                        absolute top-1/2 left-1/2 
                        -translate-x-1/2 -translate-y-1/2"
            >
                <div>
                    <Typography id="modal-modal-title" variant="h5" component="h2" style={{"fontFamily":"Montserrat"}}>
                        Please select payment option:
                    </Typography>

                    {formData?.parcelSizes?.rates?.length > 0 && (
                        <div className="ml-4 mt-5" style={{"fontFamily":"Montserrat"}}>
                            Amount to be paid:{" "} <b> R{ formData.parcelSizes.rates.find( r => r?.service_level?.code === formData.parcelPrice )?.rate } </b>
                        </div>
                    )}

                    {paymentLoading && (
                        <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-50 rounded-xl">
                            <CircularProgress />
                        </div>
                    )}
                    <div className="mb-2">
                        <SelectPaymentOptions set_payment_option={setPaymentOptionNow} selected_payment={selectedPaymentOption}/>
                    </div>
                    <div className="mb-4">
                        <div className="mb-2"><span style={{"fontFamily":"Montserrat"}}><b>Note:</b> You will be redirected to the payment page after you select an option.</span></div>
                       
                    </div>
                </div>
                <button className="bg-red-600 text-white py-1 px-3 rounded-sm hover:bg-red-800" style={{"fontFamily":"Montserrat"}} onClick={closepaymentOptionModal}>Close</button>
            </Box>
        </Modal>
    </Fragment>
}

const renderServiceForm = (type, formData = {}) => {
    switch (type) {
        case "pp_to_locker":
        case "kiosk_to_locker":
            return <LockerForm type={type} />;
        case "pp_to_kiosk":
        case "kiosk_to_kiosk":
            return <KioskForm type={type} />;
        case "pp_to_pp":
        case "kiosk_to_pp":
            return <ParcelPointForm type={type} />;
        case "pp_to_door":
        case "kiosk_to_door":
            return <DoorForm type={type} data={formData}/>;
        default:
            return null;
    }
}

export default ServiceSwitch;